<template lang="jade">
  input(type="hidden"
        ":value"="inputValue"
        ":name"="fdata.field")
  div.Autocomplete
    div.Autocomplete__field
      include ./_partials/autocomplete.jade
      div.Autocomplete__loader(v-show="request.processing")
        div.loader
    ul.Autocomplete__list(v-show="showList")
      li.Autocomplete__item(v-for="(index, item) in items"
                            "v-bind:class"="{ 'Autocomplete__item--active': index === active }"
                            @click="submit(item, index)"
                            @keydown.enter="submit(item, index)") {{{ item.text }}}
</template>

<script>
  import _ from 'lodash'
  // import { vsprintf } from 'sprintf-js'
  import serialize from 'form-serialize'
  import { forms,
           skins,
           workflow } from 'src/vuex/getters.js'
  import { addNotification,
           removeNotification,
           setFormData } from 'src/vuex/actions.js'
  // import inputs from '../_shared/traits'
  import { AutoComplete, Submit } from 'src/services/resources'

  export default {
    // mixins: [inputs],
    data () {
      return {
        query: '',
        inputValue: '',
        show: false,
        request: {
          processing: false,
          duration: 0
        },
        results: [],
        active: 0,
        items: [],
        linked: {},
        enabled: false,
        uid: this.$parent.uid,
        options: {
          hightlightTag: 'span',
          hightlightClass: 'Autocomplete__highlight'
        }
      }
    },
    computed: {
      required () {
        return _.some(this.fdata.validation, ['rule', 'required']) || this.$parent.mandatory
      },
      disabled () {
        let {editable, parameterFields} = this.fdata
        return !(!editable || (parameterFields.length > 0 && !this.enabled))
      },

      showList () {
        return this.show && this.items.length > 0
      },

      form () {
        return _.find(this.forms, ['uid', this.uid])
      },

      index () {
        return _.findIndex(this.forms, ['uid', this.uid])
      },

      headers () {
        let header = _.find(this.workflow, ['uid', this.uid])
        return {
          headers: {
            'X-FORMID': header.fid,
            'X-FINGERPRINT': header.fingerprint,
            'X-SITEID': header.sid
          }
        }
      }
    },

    props: {
      fdata: {
        type: Object
      }
    },

    vuex: {
      getters: { forms, skins, workflow },
      actions: {
        addNotification,
        removeNotification,
        setFormData
      }
    },

    watch: {
      'form.data': 'dependencies',
      inputValue: 'dispatch'
    },

    methods: {
      dispatch () {
        this.$dispatch('fdata::input', {
          [this.fdata.field]: this.inputValue
        })
      },
      /**
      * Check if required field dependencies contain data
      */
      dependencies (formData) {
        let params = this.fdata.parameterFields
        if (_.isEmpty(params)) return false

        let linked = _.reduce(params, (result, prop) => {
          return formData[prop] ? _.set(result, prop, formData[prop]) : result
        }, {})

        this.enabled = !_.isEmpty(linked)
        this.$set('linked', linked)
      },
      /**
       * Enterkey Press
       * Check if we have an active hover state on one of the drop down items
       * 'active' and we check that it is the bounds of how many results we have
       * if we meet the critera then we trigger the submitSearch
       */
      enterPress () {
        if (this.active >= 0 && (this.active + 1) <= this.items.length) {
          this.submit(this.items[this.active])
        }
      },
      /**
       * CycleUp
       * Cycle through the list of results using the up key.
       * If we are at the top of the list and the up key is pressed then
       * set the active to the bottom item in the list else we just decrement
       * the active index.
       * Finally call addValueByIndex on each press to set the value in the textbox
       */
      cycleUp () {
        this.active = this.active <= 0
          ? this.items.length - 1
          : this.active - 1
        this.addValueByIndex(this.active)
      },
      /**
       * CycleDown
       * Cycle through the list of results with the down key.
       * If we are ar the bottom of the list and the down key is pressed then
       * move the user back to the top of the result set else we just increment the
       * active index
       * Finally call addValueByIndex on each press to set the value in the textbox
       */
      cycleDown () {
        if ((this.active + 1) >= this.items.length) {
          this.active = 0
        } else {
          this.active++
        }
        this.addValueByIndex(this.active)
      },
      /**
       * Send the search query.
       * firstly we detect what key was pressed to determine the action
       * if the key that is pressed is used for navigation then break as we do not
       * want to send another request for data if a user is just scrolling through the result set.
       * If we are then executing a search first thing is to build the packet of information needed
       * if we have any linked fields then we loop over them and add them on to the request.
       * Next we perform some clean up tasks by setting the active record to -1 and set the
       * loading state to active then wipe the results.
       * Finally we send the request and manage the response rendering the temoplate of information
       * and adding any highlighting
       */
      search (data) {
        if (_.includes([40, 38, 13], data.keyCode)) return false
        // if (_.isEmpty(this.query.length)) return false
        const queryData = _.assign({}, this.linked, { query: this.query,
                                                      autocompleteId: this.fdata.autocompleteId,
                                                      startRow: 0,
                                                      rows: 100 })
        this.active = -1
        this.$set('request', {
          processing: true,
          duration: Math.floor(Date.now() / 1000)
        })
        AutoComplete.get(this.fdata.autocompleteId, queryData, this.headers)
          .then(this.success)
      },

      success (res) {
        this.results = res.data.results
        let ts = Math.floor(Date.now() / 1000)
        let duration = (ts - this.request.duration >= 1) ? 0 : 250
        setTimeout(() => {
          this.$set('request', {
            processing: false,
            duration: 0
          })
          this.$set('items', this.optionMap(this.results))
        }, duration)
      },
      optionMap (opts) {
        if (opts.length === 0) {
          return [{
            value: '',
            display: '',
            text: 'No results were found...'
          }]
        }
        return _.map(opts, xs => {
          return {
            value: xs[this.fdata.valueIndex].v,
            display: xs[this.fdata.displayValueIndex].v,
            text: this.format(xs)
          }
        })
      },
      format (data) {
        return this.fdata.listTemplate.reduce((str, xs) => {
          switch (xs.type) {
            case 'type_data':
              let text = data[xs.index]
              let formatted = !_.isNil(text.h) ? this.highlightText(text.v, text.h) : text.v
              return str.concat(formatted)
            case 'type_text':
              return str.concat(xs.value)
            default:
              return str
          }
        }, '')
      },
      /**
       * Highlight the result set.
       * Loop each item in the result, check if there is a highlight tag assosiated
       * if there is then we run the result through sprintf to add the highlight tag
       * on.
       * If we have no hightlightTag the we store out vh(value highlighted) as just the value
       * to make the logic easier later on.
       */
      highlightText (item, position) {
        let compile = _.template('<%= before %><span class="Autocomplete__highlight"><%= highlighted %></span><%= after %>')
        let start = _.head(position)
        let end = _.last(position)
        return compile({
          before: item.substring(0, start),
          highlighted: item.substring(start, end),
          after: item.substring(end, item.length)
        })
      },

      /**
       * submit the search
       * This method is used to basically select a result.
       * We do some basic clean up on each call to this method and assign the relevent values.
       * If the form has any onchange modifiers then trigger them.
       * A couple of fields need to be added to the form serialization to make sure it works
       * button and onChangeField... these just allow us to bypass the button validation
       * in the backend API
       * We then just send the request and handle the response.
       */
      submit (item) {
        let items = item['key'] !== undefined ? this.items[this.active] : item
        this.wipeResults()
        this.query = items.display
        this.inputValue = items.value
        if (this.fdata.onChange.actions.length > 0) {
          const formData = serialize(
            document.getElementById(this.uid), {
              hash: true,
              disabled: true,
              empty: true
            }
          )

          formData['button'] = 'onChange'
          formData['onChangeField'] = this.fdata.field

          Submit.post(formData, this.headers)
            .then(response => { console.log(response) })
            .catch(response => { console.log(response) })
        }
      },
      /**
       * Add a value to the search box by an index id.
       * we just use the index of the list item and extract the associated values
       */
      addValueByIndex (index) {
        this.query = this.items[index].displayValue
        this.inputValue = this.items[index].value
      },
      /**
       * Set the active ID to provided index
       */
      setActive (index) {
        this.active = index
      },
      /**
       * Clear the results
       */
      wipeResults () {
        this.items.splice(0, this.items.length)
      },

      /**
       * Register event listeners for value changes
       * Add a debounce method of 100ms to give the DOM a chance to update.
       */
      registerEventListeners (element, events) {
        events.forEach(val => {
          element.addEventListener(val, _.debounce(e => this.changeEvent(e), 100))
        }, this)
      }
    },
    /**
     * Component ready function
     */
    ready () {
      if (this.fdata.errors !== undefined &&
        this.fdata.errors.length) {
        this.fdata.errors.forEach(x => {
          this.addNotification({type: 'error',
                                msg: [x],
                                id: _.uniqueId(),
                                timeout: 6000,
                                onComplete: 'remove',
                                show: true})
        })
      }
      if (this.fdata.value) {
        this.submit({value: this.fdata.value,
                     display: this.fdata.displayValue})
      }
      /**
       * Add an event listener for so if the user clicks out of the results dropdown
       * then close the results box and wipe the data.
       */
      document.addEventListener('click', (e) => {
        if (this.$el === null || !this.$el.contains(e.target)) {
          this.wipeResults()
        }
      }, false)
    }
  }
</script>



// WEBPACK FOOTER //
// autocomplete.vue?b019f9ce